var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7674 2.22048V3.90838H9.65844V2.22048H12.7674ZM4.99502 2.22048V7.28416H1.88608V2.22048H4.99502ZM12.7674 8.97205V14.0357H9.65844V8.97205H12.7674ZM4.99502 12.3478V14.0357H1.88608V12.3478H4.99502ZM14.3219 0.532593H8.10396V5.59627H14.3219V0.532593ZM6.54949 0.532593H0.331604V8.97205H6.54949V0.532593ZM14.3219 7.28416H8.10396V15.7236H14.3219V7.28416ZM6.54949 10.6599H0.331604V15.7236H6.54949V10.6599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.02951508dfb3f657fbc373e3459b2678.svg";
export { ForwardRef as ReactComponent };